<template lang="pug">
.shortcut-report(v-loading="loading")
  .shortcut-subFinalScope-titleBar
    title-bar
      span {{ $t('结案信息') }}
      span(
        v-if="isVendor && subFinalScopeInfo.report_path"
        :class="[!isFinish ? 'active' : 'disabled']"
        @click="onConfirm"
      )
        i.iconfont.icon-chucun(v-if="canEdit")
        i.iconfont.icon-bianji(v-else)
  el-button(
    v-if="showConfirmReportBtn"
    @click="handleConfirmReport"
    type="text"
    style="font-size: 14px;display: flex;margin-left: auto"
    :disabled="isFinish"
  ) {{ $t('确定结案信息') }}
  p(
    v-if="!isVendor && !subFinalScopeInfo.report_path"
    style="color:#7f838a; margin:20px"
  ) {{ $t('供应商尚未填写结案信息！') }}
  template(v-else)
    el-row(
      v-if="hasSync && canEdit"
      style="margin-left: 20px"
    )
      el-col(:span="4") {{ $t('同步结案信息') }}
      el-col(:span="4")
        el-progress(
          v-if="isSyncing"
          :percentage="syncPercentage"
        )
        div.final-report-upload__sync(
          v-else
          @click="sync"
        )
          i.iconfont.icon-jinhangzhong
          span {{ $t('点击同步') }}
          el-tooltip(
            :content="$t('“点击同步”将从UniDam系统同步相关项目结案信息')"
            placement="top"
            :style="{ marginLeft: '5px' }"
          )
            i.el-icon-question
    el-row(
      v-if="!hasSync || (hasSync && syncSuccess) || !canEdit || subFinalScopeInfo.report_path"
      style="margin-left: 20px"
    )
      el-col(
        :span="4"
        style="padding-right: 3px"
        :class="{ required: canEdit && isVendor }"
      ) {{ $t('结案信息') }}
      el-col(
        :span="10"
        v-if="hasEditPermission && isVendor && canEdit && !hasSync"
      )
        div(
          :style="{ display: 'flex',alignItems: 'center' }"
        )
          new-upload-file(
            axiosUrl="/management/subfinal/saveFile"
            :params="uploadParams"
            @loadingChange="status => loading = status"
            @uploadSuccess="res => uploadSuccess(res)"
          )
          uploaded-file-display(
            style="margin-left: 5px"
            class="uploaded-file-display"
            :fileName="report.name"
            :downloadUrl="report.downloadPath"
            :fileNameList="report.files"
            width="85px"
          )
      el-col.text-overflow(:span="10" v-else)
        a(
          v-if="report.downloadPath"
          target="_blank"
          :href="report.downloadPath"
        ) {{ report.name}}
        span(v-else) —

    el-row(
      v-if="!hasSync || (hasSync && syncSuccess) || !canEdit || subFinalScopeInfo.report_path"
      style="margin-left: 20px"
    )
      el-col(
        :span="4"
        style="padding-right: 3px"
        :class="{ required: canEdit && isVendor }"
      ) {{ $t('完成情况') }}
      el-col(:span="20" v-if='kpi')
        kpi-situation(
          v-model="kpi"
          :viewData="kpi"
          :isEdit="isVendor && hasEditPermission && canEdit && !syncSuccess"
        )

    el-row(
      v-if="(hasSync && isPull) && matterTable"
      style="margin-left: 20px"
    )
      el-col(:span="4") {{ $t('素材管理') }}
      el-col(:span="20")
        el-table(:data="matterTable")
          el-table-column(
            :label="$t('服务项目')"
            prop="service_item_name"
          )
          el-table-column(
            :label="$t('报价数量')"
            prop="number"
          )
            template(slot-scope="scope")
              span {{ scope.row.number != null ? scope.row.number : '—' }}
          el-table-column(
            :label="$t('完成数量')"
            prop="complete_num"
          )

    el-row(style="margin-left: 20px")
      el-col(:span="4") {{ $t('结案报价') }}
      el-col(:span="20")
        el-button(@click="onStartQuotationEdit") {{ !canEdit ? $t('查看报价') : $t('修改报价') }}
    el-row(style="margin-left: 20px")
      el-col(:span="19" :offset="4")
        QuotationOverview(:data="quotation.price_overview" :shouldShowIncrement="!isVendor && quotation.summary.increment_ratio !== 0")

    quotation-dialog(
      v-if="quotationDetail.length !== 0"
      :visible="editDialogVisible"
      :data="quotationDetail"
      :hasFilled="true"
      :viewMode="!isVendor || !canEdit"
      @close="onClose"
      :checkIsAsset="true"
      :hasSync="hasSync"
    )

    el-row(v-if="showSaveButton" style="margin-left: 20px")
      el-col(:span="4" :offset="4")
        el-button(
          type="primary"
          style="width: 140px"
          @click="onSubmit"
        ) {{ $t('保存') }}
</template>

<script>
import axios from 'axios'
import { format4backend } from '@/umcc/util'
import UploadMultipleFile from '@/components/UploadMultipleFile'
import KpiSituation from '@/components/KpiSituation'
import NewUploadFile from '@/components/NewUploadFile'
import UploadedFileDisplay from '@/components/UploadedFileDisplay'
import { KPIMap } from '@/umcc/constant.js'
import TitleBar from '@/components/TitleBar'
import QuotationOverview from '@/components/QuotationOverview'
import QuotationDialog, { normalizeQuotation, formatParams } from '@/components/QuotationDialog'
import { pickBy, flatten } from 'lodash'
import FillInQuotation from '@/components/FillInQuotation'

const getExpressVendorQuotation = id => {
  return axios.get('/management/subfinalExpress/getExpressVendorQuotation', {
    params: {
      sub_final_scope_vendor_id: id,
      type: 2
    }
  })
}

const updateVendorQuotation = (params) =>
  axios.post('/management/subfinalExpress/updateVendorQuotationForFinal', format4backend(params))

const defaultMatterTable = [
  {
    service_item_name: '—',
    number: '—',
    complete_num: '—'
  }
]

export default {
  components: {
    UploadMultipleFile,
    KpiSituation,
    NewUploadFile,
    UploadedFileDisplay,
    TitleBar,
    QuotationOverview,
    QuotationDialog,
    FillInQuotation
  },
  data () {
    return {
      filePath: '',
      kpi: this.$store.state.campaign.subFinalScopeInfo.kpi,
      report: {
        serverPath: '',
        downloadPath: '',
        name: '',
        files: []
      },
      hasEditPermission: true,
      loading: false,
      canEdit: false,
      isSaved: false,
      subFinalScopeInfo: {},
      hasSync: false,
      isSyncing: false,
      syncPercentage: 0,
      syncSuccess: false,
      syncHasIncrement: null,
      editDialogVisible: false,
      isFinish: false,
      quotationParams: null,
      subFinalScopeVendorId: null,
      quotation: {},
      quotationDetail: [],
      matterTable: null,
      isPull: false
    }
  },
  computed: {
    isVendor () {
      return this.$store.state.common.user.is_vendor
    },
    uploadParams () {
      return {
        file_type: 3
      }
    },
    subFinalScopeId () {
      return this.$store.state.campaign.subFinalScopeId
    },
    showSaveButton () {
      return this.isVendor && !this.subFinalScopeInfo.report_path && this.hasEditPermission
    },
    showConfirmReportBtn () {
      return this.$store.state.common.user.permissions.indexOf('Confirm_Vendor_Quotation') !== -1 && this.subFinalScopeInfo.report_path
    }
  },
  mounted () {
    if (this.subFinalScopeId) {
      this.getBusinessSetting()
      this.getSubFinalScopeInfo()
      this.checkIfSync()
      this.fetchAssets()
    }
  },
  beforeRouteLeave (to, from, next) {
    if ((this.isVendor && this.canEdit && this.hasEditPermission && !this.isSaved)) {
      this.$confirm(this.$t('离开本页面，已更改的信息将不会被保存。'), this.$t('提示'), {
        confirmButtonText: this.$t('确定'),
        cancelButtonText: this.$t('取消')
      })
        .then(() => {
          next()
          if (window.changeTabCB) {
            window.changeTabCB()
            window.changeTabCB = null
          }
        })
        .catch(() => {
          window.changeTabCB = null
          return next(false)
        })
    } else {
      next()
      if (window.changeTabCB) {
        window.changeTabCB()
        window.changeTabCB = null
      }
    }
  },
  methods: {
    fetchAssets () {
      axios.get('/management/subfinal/getAssetList', {
        params: {
          sub_final_scope_id: this.subFinalScopeId
        }
      })
        .then(res => {
          this.matterTable = res.length !== 0 ? res : defaultMatterTable
        })
    },
    onClose (res, params) {
      this.editDialogVisible = false
      if (res) {
        this.quotation = res
        this.quotationDetail = res.vendor_price.map(item => normalizeQuotation(item))
        this.quotationParams = params
      }
    },
    async fetchQuotationData () {
      // if (this.loading) return
      this.loading = true
      const res = await getExpressVendorQuotation(this.subFinalScopeVendorId)
      this.quotation = res
      this.quotationDetail = res.vendor_price.map(item => normalizeQuotation(item))
      this.getQuotationParams()
      this.loading = false
    },
    getQuotationParams () {
      const result = this.quotation.vendor_price.map(category => normalizeQuotation(category))
      const serviceItem = flatten(result.map(item => item.tableData.map(o => ({ service_item_name: o.serviceItemName, service_item_id: o.serviceItemId }))))
      this.quotationParams = {
        sub_final_scope_vendor_id: this.subFinalScopeVendorId,
        service_item: serviceItem.map(i => [{ service_item_name: i.service_item_name, service_item_id: i.service_item_id }]),
        vendor_offer_price: flatten(result.map(item => {
          return item.tableData.map(o => {
            const res = {
              category_id: item.categoryId,
              service_id: o.serviceId,
              unit_price: o.unitPrice,
              number: o.number,
              total_price: o.totalPrice,
              detail_path: o.detail.serverPath,
              remark: o.remark,
              solutions_name: o.solutionsName,
              price_after_leveraging: o.priceAfterLeveraging,
              coverage_start_date: o.dateRange[0],
              coverage_end_date: o.dateRange[1],
              service_item_id: o.serviceItemId
            }
            return pickBy(res, v => { return v != null })
          })
        })),
        vendor_offer_discount: result.map(o => {
          return {
            category_id: o.categoryId,
            discount: o.discount
          }
        })
      }
    },
    handleConfirmReport () {
      this.$confirm(this.$t('结案信息确认后将不可再修改，请确定是否继续。'), this.$t('提示'), {
        confirmButtonText: this.$t('确定'),
        cancelButtonText: this.$t('取消')
      })
        .then(() => {
          axios.get('/management/subfinalExpress/confirmFinalReport', {
            params: {
              sub_final_scope_id: this.subFinalScopeId
            }
          })
            .then(() => {
              this.$message.success(this.$t('确定结案信息成功'))
              this.$store.dispatch('campaign/updateSowProcess', this.subFinalScopeId)
              this.getBusinessSetting()
            })
        })
    },
    onStartQuotationEdit () {
      if (!this.canEdit) {
        this.editDialogVisible = true
      } else {
        this.$confirm(this.$t('更新报价需要重新审核，请确定是否继续?'), this.$t('提示'), {
          confirmButtonText: this.$t('确定'),
          cancelButtonText: this.$t('取消')
        })
          .then(() => {
            this.editDialogVisible = true
          })
      }
    },
    sync () {
      this.syncPercentage = 0
      this.isSyncing = true
      let addPercent = setInterval(() => {
        this.syncPercentage += 2
        if (this.syncPercentage === 98) {
          clearInterval(addPercent)
        }
      }, 150)
      axios
        .get('/management/subfinal/pullFinalReport', {
          params: {
            sub_final_scope_id: this.subFinalScopeId
          }
        })
        .then((res) => {
          this.syncHasIncrement = res.has_increment
          this.syncPercentage = 100
          this.isSyncing = false
          this.syncSuccess = true
          this.isPull = true
          this.log = res
          this.report.serverPath = res.file_path
          this.report.downloadPath = res.download_url
          this.report.name = res.file_name
          this.report.files = res.file_name_list
          this.kpi = res.sub_final_scope_kpi
          this.matterTable = res.asset_list.length !== 0 ? res.asset_list : defaultMatterTable
          this.quotation = res.price
          this.quotationDetail = res.price.vendor_price.map(item => normalizeQuotation(item))
          this.getQuotationParams()
        })
        .catch(() => {
          clearInterval(addPercent)
          this.isSyncing = false
        })
    },
    checkIfSync () {
      axios
        .get('/management/subfinal/checkThirdParty', {
          params: {
            sub_final_scope_id: this.subFinalScopeId
          }
        })
        .then((res) => {
          this.hasSync = res.can_submit
          this.isPull = res.is_pull === 1
        })
    },
    async getSubFinalScopeInfo () {
      try {
        this.subFinalScopeInfo = await axios.get('/management/subfinalExpress/getSubFinalScope', {
          params: {
            sub_final_scope_id: this.subFinalScopeId
          }
        })
        this.kpi = this.subFinalScopeInfo.kpi
        this.report.name = this.subFinalScopeInfo.report_name
        this.report.serverPath = this.subFinalScopeInfo.report_path
        this.report.downloadPath = this.subFinalScopeInfo.report_download_path
        this.report.files = this.subFinalScopeInfo.report_name_list
        this.subFinalScopeVendorId = this.subFinalScopeInfo.sub_final_scope_vendor_id
        this.fetchQuotationData()
        if (!this.subFinalScopeInfo.report_path) {
          this.canEdit = true
        }
        this.$store.commit('campaign/setSubFinalScopeInfo', this.subFinalScopeInfo)
      } catch (err) {
        throw new Error(err)
      }
    },
    uploadSuccess (res) {
      this.report = {
        serverPath: res.file_path,
        downloadPath: res.file_download_path,
        name: res.file_name,
        files: res.file_name_list
      }
      this.loading = false
    },
    async onSubmit () {
      if (!this.validateParams()) return
      try {
        this.loading = true
        // console.log('hasIncremetn', this.quotationParams)
        if (this.quotationParams || this.syncHasIncrement) {
          const incrementQuotationParams = formatParams(this.subFinalScopeVendorId, this.quotationDetail)
          const quotationParams = this.quotationParams ? this.quotationParams : incrementQuotationParams
          quotationParams.plan_path = this.report.serverPath
          await updateVendorQuotation(quotationParams)
          await axios.post('/management/subfinalExpress/uploadFinalReport', format4backend(this.getParams()))
        } else {
          await updateVendorQuotation(this.quotationParams)
          await axios.post('/management/subfinalExpress/uploadFinalReport', format4backend(this.getParams()))
        }
        await this.getSubFinalScopeInfo()
        this.$message.success(this.$t('保存成功'))
        this.canEdit = false
        this.isSaved = true
        this.loading = false
      } catch (error) {
        this.loading = false
        if (error.message === this.$t('结案信息已被确认，当前更改内容将不会保存')) {
          this.$message.warning(error.message)
          this.getBusinessSetting()
          this.getSubFinalScopeInfo()
          this.checkIfSync()
        }
      }
    },
    getParams () {
      const subFinalScopeKpi = this.kpi.map(i => {
        const res = {
          kpi_id: i.kpi_id,
          target: i.target,
          actual: i.actual,
          actual_percent: i.actual_percent
        }
        if (i.file_path !== 'null' && i.file_path != null) res.file_path = i.file_path
        return res
      })

      return {
        sub_final_scope_id: this.subFinalScopeInfo.sub_final_scope_id,
        sub_final_scope_vendor_id: this.subFinalScopeInfo.sub_final_scope_vendor_id,
        file_path: this.report.serverPath,
        sub_final_scope_kpi: subFinalScopeKpi,
        is_pull: this.isPull ? 1 : 0
      }
    },
    validateParams () {
      if (!this.report.serverPath) {
        this.$message.error(this.$t('请上传结案信息'))
        return false
      }
      if (this.kpi.some(i => i.actual == null || i.actual === '' || i.actual < 0)) {
        this.$message.error(this.$t('请填写正确的KPI'))
        return false
      }

      // if (this.kpi.some(i => !checkIsNonnegativeInteger(i.actual_percent))) {
      //   this.$message.error(this.$t('完成比例必须为非负整数'))
      //   return false
      // }

      for (let i = 0; i < this.kpi.length; i++) {
        if (KPIMap.find(k => k.kpiId === this.kpi[i].kpi_id) && !(KPIMap.find(k => k.kpiId === this.kpi[i].kpi_id).validate(this.kpi[i].actual))) {
          this.$message.error(this.$t(KPIMap.find(k => k.kpiId === this.kpi[i].kpi_id).validateMessage))
          return false
        }
      }
      return true
    },
    async upload (inst) {
      const formData = new window.FormData()
      formData.append('file', inst.file)
      formData.append('file_type', 3)
      const res = await axios.post('/management/subfinal/saveFile', formData)
      this.report = {
        serverPath: res.file_path,
        downloadPath: res.file_download_path,
        name: res.file_name,
        files: res.file_name_list
      }
    },
    updateBusinessSetting (setting) {
      this.hasEditPermission = setting.parent_is_edit === 1 ? setting.is_edit === 1 : false
      if (this.isVendor && !this.subFinalScopeInfo.report_path && !this.hasEditPermission) {
        this.$message.warning(this.$t('当前页面无法编辑，请联系业务支持'))
      }
    },
    onConfirm () {
      if (this.isFinish) return
      if (this.canEdit) {
        this.onSubmit()
      }
      this.canEdit = !this.canEdit
    },
    getBusinessSetting () {
      axios.get('/common/getBusinessSetting', {
        params: {
          business_id: this.subFinalScopeId, // subfinalScopeId 或 campaignId
          business_type: 2, // subFinalScope
          module_type: 3
        }
      })
        .then(res => {
          this.isFinish = Boolean(res.is_finish)
        })
    }
  }
}
</script>

<style lang="stylus">
.shortcut-report .kpi-situation .uploaded-file-display span
  width 80px !important
  overflow hidden
  text-overflow ellipsis
  white-space nowrap
.final-report-upload__sync
  color $main
</style>
